module.exports = "/_next/static/images/383b014c95e440c9d31496137d3c3722-careers@0.5x.jpg.webp";